@if(item){

<section>

    <div class="dialog_content">

        <div class="headline">
            <div class="category" [ngStyle]="{'background-color': item.category === 'User Story' ? 'blue' : item.category === 'Technical Task' ? '#1fd7c1' : 'gray'}">
                {{ item.category }}
            </div>
            
            <div class="close_btn" (click)="closeDialog()">
                <img src="./assets/contact/Close.svg" alt="close">
            </div>
        </div>

        <h1 class="title_content">{{item.title}}</h1>
        <h4>{{item.description}}</h4>

        <div class="date_prio_content">
            <p class="title2">Due date:</p>
            <p>{{ formatDate(item.date) }}</p>
        </div>
        <div class="date_prio_content">
            <p class="title2">Priority:</p>
            <div class="priority"> <p>{{item.priority | titlecase }}</p>
                @if (item.priority === "urgent") {
                    <img src="./assets/tasks/Prio alta.svg" alt="">
                } @else if(item.priority === "medium") {
                    <img src="./assets/tasks/Prio media.svg" alt="">
                } @else if(item.priority === "low") {
                    <img src="./assets/tasks/Prio baja.svg" alt="">
                }
            </div>
           
        </div>

        <div class="assigned_content">
            <p class="title2">Assigned To:</p>
            <div class="members_content">
                <div class="assigned_to">
                    @if(item.assignedToUserId && item.assignedToUserId.length > 0) {
                        @for (userId of item.assignedToUserId; track $index) {
                            @for (contact of firebase.orderedContactsList; track $index) {
                                @if(contact.id === userId) {
                                    <div class="person_box">
                                    <div class="color_icon" [ngStyle]="{'background-color': contact.color}">
                                        <p>{{contact.firstname.charAt(0)}}{{contact.lastname.charAt(0)}}</p>
                                    </div>
                                    <p>{{contact.fullname| titlecase }}</p>
                                </div>
                                }
                            }
                        } 
                    } @else {
                        <p>no users assigned</p>
                    }
                </div>
            
            </div>
        </div>

        <div class="subtasks_content">
            <p class="title2">Subtasks</p>
    
            <div class="show_subtask" >
                <label class="checkbox_content" *ngFor="let subtask of item.subtasks; let i = index">
                    <input 
                        type="checkbox" 
                        [checked]="subtask.isCompleted" 
                        (change)="updateSubtaskStatus(item.id, i)"
                    >
                    <img class="unchecked" src="./assets/tasks/checkbox-unchecked.svg" alt="unchecked" *ngIf="!subtask.isCompleted">
                    <img class="checked" src="./assets/tasks/checkbox-checked.svg" alt="checked" *ngIf="subtask.isCompleted">
                    <p>{{subtask.subtask}}</p>
                </label>
            </div>
        </div>
        

        <div class="delete_edit_content">
            <div class="delete_box" (click)="opendeleteDialog(item)">
                <img src="./assets/contact/delete.svg" alt="delete">
                <p>Delete</p>
            </div>
            <img src="/assets/tasks/Vector 3.svg" alt="">
            <div class="edit_box" (click)="openEditDialog(item)">
                <img src="./assets/contact/edit.svg" alt="edit">
                <p>Edit</p>
            </div>
        </div>
    </div>

         <!-- Open deleteDialog -->
         <div *ngIf="isDeleteOpen" class="overlay_content" (click)="closeEditDialog()">
            <div class="custom-dialog">
                <app-delet-card-dialog [item]="selectedItem" class="delet-dialog" (closeDialogEvent)="closeEditDialog()"  (contactDeletedEvent)="onTaskDeleted()" (click)="stopPropagation($event)"></app-delet-card-dialog>
            </div>
        </div>

       <!-- Open Edit Dialog -->
       <div *ngIf="isDialogOpen" class="overlay_content" (click)="closeEditDialog()">
        <div class="custom-dialog">
            <app-edit-dialog [item]="selectedItem" (saveChangesEvent)="updateTask($event)" (closeDialogEvent)="closeEditDialog()" (click)="stopPropagation($event)"></app-edit-dialog>
        </div>
    </div>

</section>
}